module.exports = __webpack_public_path__ + "img/hr-brown-fluff-02.7beab9df.png";